import React, { useRef, useEffect, useState } from 'react';
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import shop from "../shop.png";

mapboxgl.accessToken = process.env.REACT_APP_MAP_TOKEN;

export default function Map(props) {
    const mapContainer = useRef(null);
    //const map = useRef(null);
    const [lng, setLng] = useState(35.0168);
    const [lat, setLat] = useState(-15.7667);
    const [zoom, setZoom] = useState(9);
    const [geoLocArray, setGeoLocArray] = useState(props.geoArray);
    

    useEffect(() => {
        setGeoLocArray(props.geoArray);
        const map = new mapboxgl.Map({
            container: mapContainer.current,
            style: 'mapbox://styles/mapbox/satellite-streets-v11',
            center: [lng, lat],
            zoom: zoom
        });
        map.on('move', () => {
            setLng(map.getCenter().lng.toFixed(4));
            setLat(map.getCenter().lat.toFixed(4));
            setZoom(map.getZoom().toFixed(2));
        });

        map.on("load", function() {
            map.loadImage(
                shop,
                function(error, image) {
                    map.addImage("custom-marker", image);

                    //dummy location data and mechanic locations
                    var geojson = {
                        "type": "FeatureCollection",
                        "features": geoLocArray
                    };

                    map.addSource("mechPoints", {
                        "type": "geojson",
                        "data": geojson
                    });

                    map.addLayer({
                        "id": "mechSymbols",
                        "type": "symbol",
                        "source": "mechPoints",
                        "layout": {
                            "icon-image": "custom-marker"
                        }
                    });

                    // Center the map on the coordinates of any clicked symbol from the 'symbols' layer.
                    map.on("click", "mechSymbols", function(e) {
                        //console.log(e.features[0].properties.urls);

                        //var splitString = String(e.features[0].properties.urls).split(",");
                        //console.log(JSON.parse(stringArray));

                        var stringArray = e.features[0].properties.urls;
                        var object = {
                            "name" : e.features[0].properties.name,
                            "location" : e.features[0].properties.location,
                            "contactPerson" : {
                                "email" :  e.features[0].properties.conEmail,
                                "name" :  e.features[0].properties.conName,
                                "phone" :  e.features[0].properties.conPhone
                            },
                            "coordinates" : {
                                "longitude" :  e.features[0].properties.longitude,
                                "latitude" :  e.features[0].properties.latitude
                            },
                            "dateCreated" :  e.features[0].properties.dateCreated,
                            "createdByID" :  e.features[0].properties.createdBy,
                            "feedbackNotes" :  e.features[0].properties.notes,
                            "outletID" :  e.features[0].properties.outletID,
                            "urls" : JSON.parse(stringArray)
                        };

                        console.log(object);
                        props.modal(object);

                    });

                    map.on("mouseenter", "mechSymbols", function() {
                        map.getCanvas().style.cursor = "pointer";
                        //alert("some mechanic");
                    });

                    map.on("mouseleave", "mechSymbols", function() {
                        map.getCanvas().style.cursor = "";
                    });
                }
            );
        });
        return () => map.remove();
    }, [geoLocArray, props]);

    return (
        <div>
            <div className="toppie">
                Longitude: {lng} | Latitude: {lat} | Zoom: {zoom}
            </div>
            <div ref={mapContainer} className="map-container" />
        </div>
    );
}
